import { AxiosResponse } from "axios";
import { AudienciaCampania } from "../types/Campanias/AudienciaCampania";
import apiInterceptor from "../utils/axios";
import { Campanium } from "../types/Campanias/Campanium";
import { Campania } from "../types/Campanias/Campania";
import { AppSegmento } from "../types/Campanias/AppSegmento";


const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';

export default class CampaniaService {

    static async GetSegmentos(): Promise<Array<AudienciaCampania>> {
        try {
            const response1: AxiosResponse<Array<any>> = await apiInterceptor.get(`https://wstestmiespol.espol.edu.ec/api/Segmento/ObtenerSegmentos`);
            console.log(response1);
    
            // Map API response to AudienciaCampania objects
            return response1.data.map(segmento => 
                new AudienciaCampania(
                    segmento.idsegmento.toString(),  // Convert number to string
                    segmento.alias,
                    segmento.etiqueta,
                    segmento.estado
                )
            );
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return [];
        }
    }

    static async PostCampania(campa: Campanium){
        try {
            const response = await apiInterceptor.post(`${SERV_BACK}api/SaacTipoNotificaciones/PostTNmCampanium`, 

            JSON.stringify(campa),
            {
                headers: {'Content-Type':'application/json'}
            }
        );

        console.log("Campaña creada");

        console.log(response);

        } catch (error) {
            console.error("Error posting TNmTipoNotificacion:", error);
            return null;
        }
    }

    static async GetCampanias(): Promise<Array<Campanium>> {
        try{
            const response1: AxiosResponse<Array<any>> = await apiInterceptor.get(`${SERV_BACK}api/SaacCampaniums/GetAppCampanias`);
            
            // console.log(response1);
            
            return response1.data.map(cam => 
                new Campanium(
                    cam.idnmcampania,
                    cam.idpersona,
                    cam.idnmtiponotificacion,
                    cam.totalnotificacionesgeneradas ?? 0,
                    cam.totalnotificacionesenviadas ?? 0,
                    cam.estado ?? "",
                    cam.fechaplanificacionenvio ?? "",
                    cam.fechageneracionnotificaciones ?? "",
                    cam.ultimoCambio,
                    cam.segmentos.map((seg: { idnmaudiencia: number; idnmcampaniaaudiencia: number; idnmcampania: number; descripcion: string; }) => new AppSegmento(
                        seg.idnmaudiencia,
                        seg.idnmcampaniaaudiencia,
                        seg.idnmcampania,
                        seg.descripcion
                    )),
                )
            );

        }catch(error){
            console.error('Error al realizar la solicitud:', error);
            return [];
        }
    }

    static createFilas(campanias: Campania[]): any[]{
        if(campanias.length != 0){
            console.log("Campanias: "+campanias[0].plantillaId);
            return campanias.map( (camp) => ({
                plantillaId: camp.plantillaId,
                fecha: camp.fechaProg,
                hora: camp.horaProg,
                estado: camp.estado,
                acciones: "",
                campaña: camp
            }));
        }else{
            return [];
        }
    }


}